import { render, staticRenderFns } from "./AccountServicePage.vue?vue&type=template&id=5ca8bb50&scoped=true"
import script from "./AccountServicePage.vue?vue&type=script&lang=js"
export * from "./AccountServicePage.vue?vue&type=script&lang=js"
import style0 from "./AccountServicePage.vue?vue&type=style&index=0&id=5ca8bb50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca8bb50",
  null
  
)

export default component.exports